import React, { useState } from "react";
import { Share2, Check } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { useToast } from "@/hooks/use-toast";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

async function deliver(url, title) {
  if (navigator.share) {
    try { await navigator.share({ title, url }); return "shared"; } catch (e) { if (e?.name === "AbortError") return "aborted"; }
  }
  try { await navigator.clipboard.writeText(url); return "copied"; } catch { return "manual"; }
}

export default function ShareButton({ title, placeIds, url, kind = "list", className = "", testid = "share-btn", light = false, size = "h-10 w-10" }) {
  const { t } = useApp();
  const { toast } = useToast();
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [shareLink, setShareLink] = useState("");

  const handle = async () => {
    setBusy(true);
    try {
      let target = url;
      if (!target) {
        const { data } = await api.post("/shares", { title, place_ids: placeIds, kind });
        target = `${window.location.origin}/s/${data.id}`;
      }
      const res = await deliver(target, title);
      if (res === "manual") setShareLink(target);
      if (res === "copied") { toast({ title: t("link_copied") }); setDone(true); setTimeout(() => setDone(false), 2000); }
    } catch (e) {
      toast({ title: t("share_fail"), description: e?.response?.data?.detail || "", variant: "destructive" });
    } finally { setBusy(false); }
  };

  const base = light
    ? "bg-white/90 text-ink backdrop-blur hover:bg-white"
    : "bg-sand text-sea hover:bg-sea-light";
  return (
    <><button data-testid={testid} onClick={handle} disabled={busy} aria-label={t("share")} title={t("share")} className={`grid shrink-0 ${size} place-items-center rounded-full shadow-sm transition-colors active:scale-95 disabled:opacity-60 ${base} ${className}`}>
      {done ? <Check className="h-4.5 w-4.5 text-emerald-600" /> : <Share2 className="h-4.5 w-4.5" />}
    </button><Dialog open={!!shareLink} onOpenChange={(open) => !open && setShareLink("")}><DialogContent data-testid={`${testid}-dialog`} className="w-[calc(100%-2rem)] rounded-xl"><DialogHeader><DialogTitle>{t("share_link")}</DialogTitle><DialogDescription className="break-words">{title}</DialogDescription></DialogHeader><input data-testid={`${testid}-url`} aria-label={t("share_link")} readOnly value={shareLink} onFocus={(e) => e.target.select()} className="w-full min-w-0 rounded-lg border p-3 text-sm" /></DialogContent></Dialog></>
  );
}
